import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "reactstrap";

const LoginButton = (props) => {
  const { loginWithRedirect } = useAuth0();
  return <Button
    		color="primary"
    		size="lg"
            disabled={props.empresaSelected === undefined || props.empresaSelected === null}
    		onClick={() => {
				try {
					localStorage.setItem('companyData', JSON.stringify(props.empresaSelected))
					loginWithRedirect()
					props.setSignedIn(true)
				}
				catch (error) {
					console.log(error)
				}
    		}} > Ingresar
		</Button>;
};

export default LoginButton;